'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var setProductLink = exports.setProductLink = function setProductLink(link) {
    if (link.indexOf('app.90seconds') >= 0 && link.indexOf('?') >= 0) {
        return link;
    }
    return link.replace(/https?:\/\/([a-zA-Z0-9]+\.)?90seconds.[a-zA-Z0-9.]+\//, '');
};
var VIDEO_EXTENSIONS = ['3g2', '3gp', 'aaf', 'asf', 'avchd', 'avi', 'drc', 'flv', 'm2v', 'm4p', 'm4v', 'mkv', 'mng', 'mov', 'mp2', 'mp4', 'mpe', 'mpeg', 'mpg', 'mpv', 'mxf', 'nsv', 'ogg', 'ogv', 'qt', 'rm', 'rmvb', 'roq', 'svi', 'vob', 'webm', 'wmv', 'yuv'];
var IMAGE_EXTENSIONS = ['ase', 'art', 'bmp', 'blp', 'cd5', 'cit', 'cpt', 'cr2', 'cut', 'dds', 'dib', 'djvu', 'egt', 'exif', 'gif', 'gpl', 'grf', 'icns', 'ico', 'iff', 'jng', 'jpeg', 'jpg', 'jfif', 'jp2', 'jps', 'lbm', 'max', 'miff', 'mng', 'msp', 'nitf', 'ota', 'pbm', 'pc1', 'pc2', 'pc3', 'pcf', 'pcx', 'pdn', 'pgm', 'PI1', 'PI2', 'PI3', 'pict', 'pct', 'pnm', 'pns', 'ppm', 'psb', 'psd', 'pdd', 'psp', 'px', 'pxm', 'pxr', 'qfx', 'raw', 'rle', 'sct', 'sgi', 'rgb', 'int', 'bw', 'tga', 'tiff', 'tif', 'vtf', 'xbm', 'xcf', 'xpm', '3dv', 'amf', 'ai', 'awg', 'cgm', 'cdr', 'cmx', 'dxf', 'e2d', 'egt', 'eps', 'fs', 'gbr', 'odg', 'svg', 'stl', 'vrml', 'x3d', 'sxd', 'v2d', 'vnd', 'wmf', 'emf', 'art', 'xar', 'png', 'webp', 'jxr', 'hdp', 'wdp', 'cur', 'ecw', 'iff', 'lbm', 'liff', 'nrrd', 'pam', 'pcx', 'pgf', 'sgi', 'rgb', 'rgba', 'bw', 'int', 'inta', 'sid', 'ras', 'sun', 'tga'];
var isVideo = exports.isVideo = function isVideo(url) {
    return VIDEO_EXTENSIONS.includes(url.trim().substring(url.lastIndexOf('/') + 1).split('.').pop() || '');
};
var isImage = exports.isImage = function isImage(url) {
    return IMAGE_EXTENSIONS.includes(url.trim().substring(url.lastIndexOf('/') + 1).split('.').pop() || '');
};
var stripMediaExtension = exports.stripMediaExtension = function stripMediaExtension(url) {
    var MATCH_ALL_AFTER_LAST_DOT = /\.([^.]*?)(?=\?|#|$)/;
    var MATCH_LAST_DOT = /\.[^/.]+$/;
    var ext = (url.trim().match(MATCH_ALL_AFTER_LAST_DOT) || [])[1];
    if (ext && (IMAGE_EXTENSIONS.includes(ext.toLowerCase()) || VIDEO_EXTENSIONS.includes(ext.toLowerCase()))) {
        return url.replace(MATCH_LAST_DOT, '');
    }
    return url;
};
//# sourceMappingURL=product-link.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/helpers/product-link.js
// module id = 1981
// module chunks = 0